import { httpOriginFromWsUrl } from 'ts-components/PiChat/wsOrigin';

const CAPTURES_PREFIX = '/objects/sessions/';

const resolveSessionPath = (path: string, wsUrl: string): string | null => {
  if (
    !path.startsWith(CAPTURES_PREFIX) ||
    path.includes('//') ||
    path.includes('\\')
  ) {
    return null;
  }
  const origin = httpOriginFromWsUrl(wsUrl);
  if (!origin) return null;
  let resolved: URL;
  try {
    resolved = new URL(path, origin);
  } catch {
    return null;
  }
  if (
    resolved.origin !== origin ||
    !resolved.pathname.startsWith(CAPTURES_PREFIX)
  ) {
    return null;
  }
  return resolved.href;
};

const parseUrl = (url: string): URL | null => {
  try {
    return new URL(url);
  } catch {
    return null;
  }
};

export const resolveCaptureUrl = (
  url: string,
  wsUrl: string
): string | null => {
  if (url.startsWith('/')) return resolveSessionPath(url, wsUrl);
  if (!/^https:\/\//i.test(url)) return null;
  const parsed = parseUrl(url);
  if (!parsed || parsed.username || parsed.password) return null;
  return parsed.protocol === 'https:' ? parsed.href : null;
};

export const resolveUploadUrl = (url: string, wsUrl: string): string | null => {
  const resolved = resolveCaptureUrl(url, wsUrl);
  if (resolved || !/^http:\/\//i.test(url)) return resolved;
  const parsed = parseUrl(url);
  const origin = httpOriginFromWsUrl(wsUrl);
  if (
    parsed &&
    !parsed.username &&
    !parsed.password &&
    parsed.protocol === 'http:' &&
    origin !== null &&
    parsed.origin === origin &&
    parsed.pathname.startsWith(CAPTURES_PREFIX)
  ) {
    return parsed.href;
  }
  return null;
};

export const redactUrl = (url: string): string => {
  const [withoutQuery] = url.split(/[?#]/, 1);
  const redacted = withoutQuery.replace(
    /^((?:[a-z][a-z0-9+.-]*:)?\/\/)[^/]*@/i,
    '$1'
  );
  return redacted.length > 120 ? `${redacted.slice(0, 120)}…` : redacted;
};
